import axios from "../axios";

export const goodsReceiptsApi = {
  // Get all goods receipts
  getGoodsReceipts: async (params = {}) => {
    return axios.get("/inventory/goods_receipts", { params });
  },

  // Get a single goods receipt by ID
  getGoodsReceipt: async (id) => {
    return axios.get(`/inventory/goods_receipts/${id}`);
  },

  // Create a new goods receipt
  createGoodsReceipt: async (data, purchaseId = null) => {
    const payload = {
      goods_receipt: data,
    };
    if (purchaseId) {
      payload.purchase_id = purchaseId;
    }
    return axios.post("/inventory/goods_receipts", payload);
  },

  // Update an existing goods receipt
  updateGoodsReceipt: async (id, data) => {
    return axios.put(`/inventory/goods_receipts/${id}`, {
      goods_receipt: data,
    });
  },

  // Delete a goods receipt
  deleteGoodsReceipt: async (id) => {
    return axios.delete(`/inventory/goods_receipts/${id}`);
  },

  // Add item to goods receipt
  addItemToGoodsReceipt: async (goodsReceiptId, data) => {
    return axios.post(`/inventory/goods_receipts/${goodsReceiptId}/items`, {
      goods_receipt_item: data,
    });
  },

  // Update item in goods receipt
  updateItemInGoodsReceipt: async (goodsReceiptId, itemId, data) => {
    return axios.put(`/inventory/goods_receipts/${goodsReceiptId}/items/${itemId}`, {
      goods_receipt_item: data,
    });
  },

  // Remove item from goods receipt
  removeItemFromGoodsReceipt: async (goodsReceiptId, itemId) => {
    return axios.delete(`/inventory/goods_receipts/${goodsReceiptId}/items/${itemId}`);
  },
};





